import { ReactNode } from "react";
import styled from "styled-components";
import { shade900 } from "../../../styles/tokens";

// TEXT

// STYLES
export const PanelHeaderRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex: 0 0 auto;
  padding-left: 1.5rem;
  padding-right: 0.5rem;
  position: sticky;
  border-left: 1px solid ${shade900};
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
`;

// DATA

// TYPES
export type Props = {
  title: string | ReactNode;
  onClose: () => void;
  actions?: ReactNode;
  className?: string;
};

// CONSTANTS

// FUNCTIONS

// ASSETS
